// src/Pages/DashboardManagment/OurServicesPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ActiveModulesCard from "./DashboardComponents/ActiveModulesCard";
import { getActiveModules } from "../../redux/services/dashboardServices/dashboard.Services";
import { errorToast } from "../../Utils/toast";
import { FiArrowLeft } from "react-icons/fi";

function OurServicesPage() {
  const navigate = useNavigate();
  const { permissions } = useSelector((state) => state.auth);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await getActiveModules();
        const list = res?.data?.modules || [];
        setModules(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error(err);
        errorToast("Failed to load modules");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="main_page">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2 className="mb-1">🎛️ Our Services</h2>
          <p className="text-muted mb-0">
            Explore all modules available for your business
          </p>
        </div>
        <button className="add-btn" onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>
      </div>

      {/* ✅ Same ActiveModulesCard component */}
      <ActiveModulesCard
        modules={modules}
        loading={loading}
        subscribedMenuIds={permissions?.allowedMenus || []}
      />
    </div>
  );
}

export default OurServicesPage;